const ms = (seconds) => seconds * 1000;

export { ms };
